import Banner from "../Allcomponent/Banner"
import Cards from "../Allcomponent/cards"
import Beauty from "../Allcomponent/beauty"
function Mainblog(){
    return(
        <>
        <Banner/>
        <Cards/>
        <Beauty/>
        
        </>
    )
}
export default Mainblog